import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Alert,
  AlertTitle,
  MenuItem,
  Link
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';

const inquiryTypes = [
  'Product Information',
  'Order Status',
  'Returns & Exchanges',
  'Bee Sting Prevention Advice',
  'Wholesale Inquiries',
  'Other',
];

const Contact = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    inquiryType: '',
    message: '',
  });
  
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Validate form
    if (!formState.name || !formState.email || !formState.message) {
      setError(true);
      return;
    }
    
    // In a real app, you would send the form data to a server here
    console.log('Form submitted:', formState);
    
    // Show success message and clear form
    setSubmitted(true);
    setError(false);
    setFormState({
      name: '',
      email: '',
      inquiryType: '',
      message: '',
    });
    
    // Hide success message after 5 seconds
    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };

  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h3" 
          component="h1" 
          align="center" 
          gutterBottom
          sx={{ fontWeight: 'bold', mb: 6 }}
        >
          Contact Us
        </Typography>
        
        <Grid container spacing={4} justifyContent="center">
          {/* Contact Information */}
          <Grid item xs={12} md={5}>
            <Paper elevation={2} sx={{ p: 4, height: '100%' }}>
              <Typography variant="h5" component="h2" gutterBottom>
                Get In Touch
              </Typography>
              <Typography paragraph color="text.secondary">
                Have questions about our bee sting prevention gear? Need advice on which products 
                would best suit your needs? We're here to help!
              </Typography>
              
              {/* <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, mt: 4 }}>
                <LocationOnIcon color="primary" sx={{ mr: 2 }} />
                <Typography>
                  123 Bee Street, Honey Valley, BV 98765
                </Typography>
              </Box> */}
              
              <Typography paragraph color="text.secondary" sx={{ mb: 3, fontStyle: 'italic' }}>
                At Begard, your safety and satisfaction are at the heart of everything we do. 
                We pour our passion into crafting protective gear that keeps you comfortable 
                and confident in the great outdoors.
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <EmailIcon color="primary" sx={{ mr: 2 }} />
                <Typography>
                  <Link href="mailto:begardgear@gmail.com" color="inherit">begardgear@gmail.com</Link>
                </Typography>
              </Box>
              
              <Typography paragraph color="text.secondary" sx={{ mt: 4, fontStyle: 'italic' }}>
                Every inquiry matters to us, and we're dedicated to providing you with 
                thoughtful, personalized responses. Whether you're seeking advice on the 
                perfect gear for your next adventure or need guidance on bee sting prevention, 
                we're here to support your outdoor journey.
              </Typography>
            </Paper>
          </Grid>
          
          {/* Contact Form */}
          {/* Hiding the form by wrapping it in a false condition */}
          {false && (
          <Grid item xs={12} md={7}>
            <Paper elevation={2} sx={{ p: 4 }}>
              <Typography variant="h5" component="h2" gutterBottom>
                Send Us a Message
              </Typography>
              
              {submitted && (
                <Alert severity="success" sx={{ mb: 3 }}>
                  <AlertTitle>Message Sent!</AlertTitle>
                  Thank you for contacting us. We'll get back to you as soon as possible.
                </Alert>
              )}
              
              {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  <AlertTitle>Error</AlertTitle>
                  Please fill in all required fields.
                </Alert>
              )}
              
              <Box component="form" onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  margin="normal"
                  label="Your Name"
                  name="name"
                  value={formState.name}
                  onChange={handleChange}
                  required
                  error={error && !formState.name}
                />
                
                <TextField
                  fullWidth
                  margin="normal"
                  label="Email Address"
                  name="email"
                  type="email"
                  value={formState.email}
                  onChange={handleChange}
                  required
                  error={error && !formState.email}
                />
                
                <TextField
                  fullWidth
                  margin="normal"
                  select
                  label="Inquiry Type"
                  name="inquiryType"
                  value={formState.inquiryType}
                  onChange={handleChange}
                >
                  {inquiryTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                
                <TextField
                  fullWidth
                  margin="normal"
                  label="Your Message"
                  name="message"
                  multiline
                  rows={6}
                  value={formState.message}
                  onChange={handleChange}
                  required
                  error={error && !formState.message}
                />
                
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  endIcon={<SendIcon />}
                  sx={{ mt: 3 }}
                >
                  Send Message
                </Button>
              </Box>
            </Paper>
          </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact; 